import abi from './Facts.json';

export const contractABI = abi.abi;
export const contractAddress = '0x26b56A86403b50C860fc352011321C89d18B2164';